









































import { computed, defineComponent, onBeforeMount, PropType, ref, useRoute } from '@nuxtjs/composition-api';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppRectButton from '~/components/partials/App/AppRectButton.vue';
import { useEnotecaApp } from '~/composables/useEnotecaApp';
import { useLoadAnimation } from '~/composables/useLoadAnimation';
import { DEVICE_TYPE_FROM_QUIZ } from '~/constants/college';
import { url } from '~/utils';
import { CollegeLessonQuiz } from '~/types/common';
import { CollegeLessonType } from '~/enums';

export default defineComponent({
  components: {
    AppIcon,
    AppRectButton,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    quiz: {
      type: Object as PropType<CollegeLessonQuiz>,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const route = useRoute();
    const id = route.value.params.id;
    const { isEnotecaAppWebView } = useEnotecaApp();
    const pageNumber = parseInt(route.value.params.page);
    const isLoading = ref(true);
    const selectedNumber = ref('');
    const isSelected = computed(() => {
      return function (selectedNumber: string, index: number) {
        return Number(selectedNumber) === Number(index) + 1;
      };
    });

    // 講座の種別によって解答画面のパスを変更する
    const answerPath = computed(() => {
      switch (props.type) {
        case CollegeLessonType.BASIC:
          return {
            path: url('COLLEGE_BASIC_RESULT', { id, page: pageNumber }),
            query: {
              number: selectedNumber.value,
              from: isEnotecaAppWebView.value ? DEVICE_TYPE_FROM_QUIZ.APP : DEVICE_TYPE_FROM_QUIZ.WEB,
            },
          };
        case CollegeLessonType.AREA:
          return {
            path: url('COLLEGE_PRODUCING_AREA_RESULT', { id, page: pageNumber }),
            query: {
              number: selectedNumber.value,
              from: isEnotecaAppWebView.value ? DEVICE_TYPE_FROM_QUIZ.APP : DEVICE_TYPE_FROM_QUIZ.WEB,
            },
          };
        case 'DAILY':
          return {
            path: url('COLLEGE_QUIZ_DAILY_RESULT'),
            query: {
              number: selectedNumber.value,
              from: isEnotecaAppWebView.value ? DEVICE_TYPE_FROM_QUIZ.APP : DEVICE_TYPE_FROM_QUIZ.WEB,
            },
          };
      }
    });
    const tag = computed(() => (isEnotecaAppWebView.value ? 'a' : undefined));

    useLoadAnimation();

    onBeforeMount(() => {
      isLoading.value = false;
    });

    return { url, id, pageNumber, selectedNumber, isSelected, answerPath, tag, isLoading };
  },
});
